import { useQuery } from 'react-query'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

export default function useDealerInfo(data, router) {
  const state = useQuery(
    [data.slug, router.query],
    async () => {
      const resp = await EmpriseGroup.getDealer(
        data.slug,
        router.query?.page || 1
      )
      const listings = await Deserializer.deserialize(resp.listings)
      const dealer = await Deserializer.deserialize(resp.dealer)
      return { dealer, listings, pagy: resp.pagy }
    },
    {
      refetchOnWindowFocus: false
    }
  )
  return state
}
